import en from './en.json'
import terms from './terms'

const messages = {
  ...en,
  terms,
}

export default messages
